import { ReactNode, useCallback } from 'react'

type Props = {
  to: string
  behavior?: ScrollBehavior
  className?: string
  children?: ReactNode
}

export const ScrollLink = ({
  to,
  behavior = 'auto',
  className,
  children,
}: Props) => {
  const onClick = useCallback(() => {
    const target = document.getElementById(to)

    target?.scrollIntoView({ behavior })
  }, [to, behavior])

  return (
    <a onClick={onClick} className={className}>
      {children}
    </a>
  )
}
